import { useState } from 'react'
import { Moon, Sun, Lock } from 'lucide-react'
import Pacepro from '../pages/Pacepro'
import Logistica from '../pages/Logistica'
import Vendedores from '../pages/Vendedores'
import Pace from '../pages/Pace'
import Vipbeachtennis from '../pages/Vipbeachtennis'

const TABS = [
  { id: 'pacepro', label: 'Faturamento', icon: '', protected: false },
  { id: 'logistica', label: 'Logística', icon: '', protected: false },
  { id: 'vendedores', label: 'Vendedores', icon: '', protected: false },
  { id: 'pace', label: 'Pace', icon: '', protected: false },
  { id: 'vipbeachtennis', label: 'Vip beach tennis', icon: '', protected: true }
]

const VIP_PASSWORD = 'admin123'

export function Layout() {
  const [activeTab, setActiveTab] = useState('pacepro')
  const [darkMode, setDarkMode] = useState(false)
  const [vipPassword, setVipPassword] = useState('')
  const [vipUnlocked, setVipUnlocked] = useState(false)
  const [showPasswordPrompt, setShowPasswordPrompt] = useState(false)

  const handleTabClick = (tabId: string) => {
    const tab = TABS.find(t => t.id === tabId)

    if (tab?.protected && !vipUnlocked) {
      setShowPasswordPrompt(true)
      return
    }

    setActiveTab(tabId)
  }

  const handlePasswordSubmit = () => {
    if (vipPassword === VIP_PASSWORD) {
      setVipUnlocked(true)
      setActiveTab('vipbeachtennis')
      setShowPasswordPrompt(false)
      setVipPassword('')
    } else {
      alert('Senha incorreta!')
      setVipPassword('')
    }
  }

  const renderContent = () => {
    if (activeTab === 'vipbeachtennis' && !vipUnlocked) {
      return (
        <div className="text-center py-20">
          <p className="text-gray-500 dark:text-gray-400 text-lg">
            Acesso restrito. Clique na aba Vip beach tennis para inserir a senha.
          </p>
        </div>
      )
    }

    switch (activeTab) {
      case 'pacepro':
        return <Pacepro />
      case 'logistica':
        return <Logistica />
      case 'vendedores':
        return <Vendedores />
      case 'pace':
        return <Pace />
      case 'vipbeachtennis':
        return <Vipbeachtennis />
      default:
        return <Pacepro />
    }
  }

  return (
    <div className={darkMode ? 'dark' : ''}>
      <div className="flex h-screen bg-gray-50 dark:bg-gray-900">
        <main className="flex-1 flex flex-col">
          {/* Header */}
          <header className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-6 py-4">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2">
                <span className="text-2xl">🎾</span>
                <div>
                  <h2 className="text-xl font-bold text-gray-900 dark:text-white">
                    Pace pro
                  </h2>
                  <p className="text-xs text-gray-500 dark:text-gray-400">Dashboard de Vendas</p>
                </div>
              </div>
              <button
                onClick={() => setDarkMode(!darkMode)}
                className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition"
                title={darkMode ? 'Modo claro' : 'Modo escuro'}
              >
                {darkMode ? <Sun size={20} className="text-yellow-500" /> : <Moon size={20} />}
              </button>
            </div>
          </header>

          {/* Navigation */}
          <nav className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-6 py-3 flex gap-2 overflow-x-auto">
            {TABS.map(tab => (
              <button
                key={tab.id}
                onClick={() => handleTabClick(tab.id)}
                className={`px-4 py-2 rounded-lg font-medium transition whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'bg-blue-100 dark:bg-blue-900 text-blue-900 dark:text-blue-100 border-b-2 border-blue-600'
                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>

          {/* Password Modal */}
          {showPasswordPrompt && (
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
              <div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-2xl max-w-sm w-full mx-4">
                <div className="flex items-center gap-2 mb-4">
                  <Lock size={24} className="text-blue-600" />
                  <h2 className="text-xl font-bold text-gray-900 dark:text-white">Acesso Restrito</h2>
                </div>
                <p className="text-gray-600 dark:text-gray-400 mb-4">
                  A aba Vip beach tennis é protegida por senha. Digite a senha para acessar:
                </p>
                <input
                  type="password"
                  value={vipPassword}
                  onChange={(e) => setVipPassword(e.target.value)}
                  placeholder="Digite a senha"
                  className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  onKeyPress={(e) => e.key === 'Enter' && handlePasswordSubmit()}
                  autoFocus
                />
                <div className="flex gap-2">
                  <button
                    onClick={handlePasswordSubmit}
                    className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition"
                  >
                    Entrar
                  </button>
                  <button
                    onClick={() => {
                      setShowPasswordPrompt(false)
                      setVipPassword('')
                    }}
                    className="flex-1 bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 text-gray-900 dark:text-white font-bold py-2 px-4 rounded transition"
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Content */}
          <div className="flex-1 overflow-y-auto p-6">
            {renderContent()}
          </div>
        </main>
      </div>
    </div>
  )
}
